var config = {
  hostURL: process.env.REACT_APP_API_URL,
  apimSubscriptionKey : process.env.REACT_APP_APIM_SUBSCRIPTION_KEY,
  authnBaseURL : process.env.REACT_APP_AUTHN_BASE_URI
};

export default config;
